import _total from '@/pages/intelligence/assets/imgs/flag/total.svg';
import _gamalytic from '@/pages/intelligence/assets/svg/dataSource/gamalytic.svg';
import _vginsights from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import _appannie from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import _sensortower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import _databarin from '@/pages/intelligence/assets/svg/dataSource/databarin-bg.svg';
import { getImg } from '@/pages/home/_config/getImgs';
import SteamIcon from '@/pages/intelligence/assets/svg/dataSource/steam-icon.svg';
import AlineaIcon from '@/pages/intelligence/assets/svg/dataSource/alinea.svg';
import AlineaWhiteIcon from '@/pages/intelligence/assets/svg/dataSource/alinea-white.svg';
import MscienceIcon from '@/pages/intelligence/assets/svg/dataSource/mscience-bg.svg';
import Npdicon from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
import newzooIcon from '@/pages/home/assets/svg/dataSource/databarin.svg';
import newzoowhiteIcon from '@/pages/intelligence/assets/svg/dataSource/action-theme.svg';
import newzooGrayIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import amperewhiteIcon from '@/pages/intelligence/assets/svg/dataSource/ampere-bg-small.svg';
import playstationwhiteIcon from '@/pages/intelligence/assets/svg/dataSource/playstation-whiteicon.svg';
import annieIcon from '@/pages/intelligence/assets/svg/dataSource/appnnie.svg';
import famitsuIcon from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
import hatchetIcon from '@/pages/intelligence/assets/svg/dataSource/hatchet.svg';
import viewersIcon from '@/pages/intelligence/assets/svg/dataSource/following-orange.svg';
import EpicIcon from '@/pages/intelligence/assets/svg/dataSource/epic-bg.svg';
import _googleplay from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import _appstore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import _xbox from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import _metacritic from '@/pages/intelligence/assets/svg/dataSource/metacritic.svg';
import _opencritic from '@/pages/intelligence/assets/svg/dataSource/opencritic.svg';
import _steamdatabase from '@/pages/intelligence/assets/svg/dataSource/steamdatabase.svg';
import _pcdevice from '@/pages/intelligence/assets/svg/dataSource/pcdevice.svg';
import GSDIcon from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import _playstationbalck from '@/pages/intelligence/assets/svg/dataSource/playstation.svg';
import AmpereIcon from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';
import _databarin_ from '@/pages/intelligence/assets/svg/dataSource/databarin.svg';
import _databrainbgresized from '@/pages/intelligence/assets/svg/dataSource/databrain-bg-resized.svg';
import _databrainbluebg from '@/pages/intelligence/assets/svg/dataSource/databrain-blue-bg.svg';
import _appmagic from '@intelligence/assets/imgs/dataSource/app-magic-activated.png';
import _weixin from '@intelligence/assets/imgs/casualDailyReports/icon-weixin.png';
import _douyin from '@intelligence/assets/imgs/casualDailyReports/icon-dy.png';
import IgdbIcon from '@/pages/intelligence/assets/svg/gameInfo/igdb.svg';

const DbiImgMap = {
  _total,
  _unified: _total,
  _appannie,
  _appnnie: _appannie,
  _sensortower,
  _igdb: IgdbIcon,
  _ogdb: _databarin,
  _iegg: _databarin,
  // _databarin,
  _steamcharts: SteamIcon,
  _vginsights,
  _vginsight: _vginsights,
  // _newzoo: newzooIcon,
  _newzoo2databrain: newzooIcon,
  _newzoo: newzooGrayIcon,
  _newzoowhite: newzoowhiteIcon,
  _amperewhite: amperewhiteIcon,
  _playstationwhite: playstationwhiteIcon,
  _npd: Npdicon,
  _pnd: Npdicon,
  _mscience: MscienceIcon,
  _steam: SteamIcon,
  _source_steam: SteamIcon,
  _alinea: AlineaIcon,
  _alineaanalytic: AlineaIcon,
  _alineaanalytics: AlineaIcon,
  _alineawhite: AlineaWhiteIcon,
  _steamsales: _vginsights,
  _pcu: SteamIcon,
  _acu: SteamIcon,
  _famitsu: famitsuIcon,
  _annie: annieIcon,
  _stream: hatchetIcon,
  _hatchet: hatchetIcon,
  _viewers: viewersIcon,
  _epic: EpicIcon,
  _gsd: GSDIcon,
  _gamalytic,
  _ampere: AmpereIcon,
  _othervendor: AmpereIcon,
  _googleplay,
  _appstore,
  _xbox,
  _metacritic,
  _opencritic,
  _steamdatabase,
  _pcdevice,
  _android: _googleplay,
  _ios: _appstore,
  _playstationbalck,
  _databarin: _databarin_,
  _data_brain: _databarin_,
  _databrain: _databarin_,
  _databrainwhite: _databarin,
  _databrainbgresized: _databrainbgresized,
  _databrainbluebg: _databrainbluebg,
  _appmagic: _appmagic,
  _weixin: _weixin,
  _douyin: _douyin,
} as any;

/**
 * code: 图片code
 * source：扩展字段外部自定义源，优先从外部取，外部没有，从内部取
 */
// 通用所有数据源icon映射map
export const getDataSourceIcon = (code: string) => {
  if (typeof code !== 'string') return '';
  const imgCode = `_${code?.toLowerCase()?.trim()?.replace(/\s+/g, '')}`;
  /** 如果情报有，拿情报的，情报没有拿首页的 */
  if (DbiImgMap[imgCode]) {
    return DbiImgMap[imgCode];
  }
  return getImg(code);
};
